module.exports = __webpack_public_path__ + "img/securitybadge@3x.8e7494be.png";